<template>
    <div class="mobile-nav-menu">
        <div class="mobile-nav-menu-header" :class="{opened:isExpanded}">
            <div class="mobile-nav-menu-header__avatar" :style="avatarStyle">
                <div class="mobile-nav-menu-header__group-mark buddy-group" v-if="group.is_buddy_group"></div>
            </div>
            <div class="mobile-nav-menu-header__name">{{ visibleName }}</div>
            <div class="mobile-nav-menu-header__toggle-button" @click="isExpanded=!isExpanded"
                 :class="{'mobile-nav-menu-header__toggle-button_pushed':isExpanded}">
                <i class="fa fa-bars"></i>
            </div>
        </div>
        <div class="mobile-nav-menu-dropdown" v-show="isExpanded">
            <div class="mobile-nav-menu-item"
                 v-for="icon in actions"
                 :key="icon.label"
                 @click="onActionClick(icon)"
                 @keydown.enter="onActionClick(icon)"
                 tabindex="0"
            >
                <div class="mobile-nav-menu-item__icon"
                     :class="icon.iconType==='fa'?undefined:icon.iconClass">
                    <i :class="icon.iconClass" v-if="icon.iconType==='fa'" class="fas"></i>
                </div>
                <div class="mobile-nav-menu-item__label">{{ icon.label }}
                    <span class="mobile-nav-menu-item__badge" v-if="icon.counter!==undefined">{{ icon.counter }}</span>
                    <span class="mobile-nav-menu-item__badge mobile-nav-menu-item__badge_new"
                          v-if="icon.hasNew">NEW</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import {mapGetters} from "vuex";

    export default {
        name: "GroupPageMenuMobile",
        props: {
            group: Object,
            sharingState: Object,
        },
        data() {
            return {
                isExpanded: false,
            };
        },
        computed: {
            ...mapGetters('groupPage', {viewer_state: 'viewer_state'}),
            visibleName() {
                return this.group.name;
            },
            actions() {
                let actions = [
                    {
                        to: 'groupDetailPage-story',
                        actionType: 'router-link',
                        iconType: 'fa',
                        iconClass: 'fal fa-info',
                        label: 'About',
                    },
                    {
                        to: 'groupDetailPage-posts',
                        actionType: 'router-link',
                        iconType: 'fa',
                        iconClass: 'fal fa-photo-video',
                        label: 'Posts',
                    },
                    {
                        to: 'groupDetailPage-events',
                        actionType: 'router-link',
                        iconType: 'fa',
                        iconClass: 'fal fa-calendar-alt',
                        label: 'Events',
                    },
                    {
                        to: 'groupDetailPage-activity',
                        actionType: 'router-link',
                        iconType: 'fa',
                        iconClass: 'fal fa-history',
                        label: 'Activity',
                    },

                    {
                        id: 'group-chats',
                        label: `Group Chats`,
                        iconClass: 'group_conversations',
                        actionType: 'router-link',
                        to: 'groupDetailPage-chats',
                    },
                    {
                        id: 'talk-to-group',
                        label: `Chat with this Group`,
                        iconClass: 'talk_to_group',
                        actionType: 'event',
                        event: 'startChat',
                    },
                    {
                        id: 'settings',
                        label: `Group Settings`,
                        iconClass: 'settings',
                        actionType: 'event',
                        event: 'openSettings',
                    },
                    {
                        id: 'leave',
                        label: `Leave Group`,
                        iconClass: 'fa fa-sign-out',
                        iconType: 'fa',
                        actionType: 'event',
                        event: 'leaveGroup',
                    },
                    {
                        id: 'members',
                        label: `Group Members`,
                        iconClass: 'circle-users',
                        actionType: 'router-link',
                        to: 'groupDetailPage-members',
                    },
                    {
                        id: 'shared-stories',
                        label: `Shared Stories`,
                        iconClass: 'story',
                        actionType: 'router-link',
                        to: 'groupDetailPage-shared-stories',
                        counter: this.sharingState.stories.count,
                        hasNew: this.sharingState.stories.has_new,
                    },
                    {
                        id: 'shared-media',
                        label: `Shared Media`,
                        iconClass: 'folder',
                        actionType: 'router-link',
                        to: 'groupDetailPage-shared-media',
                        counter: this.sharingState.media.count,
                        hasNew: this.sharingState.media.has_new,
                    },
                    {
                        id: 'shared-wikis',
                        label: `Shared Wikis`,
                        iconClass: 'wiki',
                        actionType: 'router-link',
                        to: 'groupDetailPage-shared-wiki',
                        counter: this.sharingState.wiki.count,
                        hasNew: this.sharingState.wiki.has_new,
                    },

                ];

                if (!this.viewer_state.is_admin) {
                    actions = actions.filter(a => a.id !== 'settings');
                }

                return actions;
            },
            avatarStyle() {
                const mediaContentUtils = Vue.getAngularModule('mediaContentUtils');
                if (!this.group.auto_avatar) {
                    return mediaContentUtils.generate_group_background(this.group.avatar, []);
                } else {
                    return mediaContentUtils.generate_group_background(this.group.avatar, this.group.members_avatars);
                }
            },
        },
        methods: {
            onActionClick(action) {
                this.isExpanded = false;
                if (action.actionType === 'router-link') {
                    this.$router.push({...this.$route, name: action.to});
                } else if (action.actionType === 'event') {
                    this.$emit(action.event);
                }
            }
        }
    };
</script>

<style scoped lang="scss">
  @import "../../styles/const";
  @import "../../styles/mixins";

  .mobile-nav-menu {
    overflow: visible;
    position: relative;
    margin-bottom: 10px;
    @media (min-width: $screen-sm-min) {
      display: none;
    }

  }

  .mobile-nav-menu-dropdown {
    z-index: 5;
    position: absolute;
    width: 100%;
    top: 55px;
    left: 0;
    background-color: #0065b0;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .mobile-nav-menu-item {
    $line-height: 44px;
    $icon-sector-width: 50px;
    font-size: 0;
    padding: 2px 0;
    min-height: $line-height;

    width: 100%;

    &__icon {
      $icon-size: 32px;
      line-height: $line-height;
      vertical-align: middle;
      width: $icon-sector-width;
      color: #fff;
      font-size: 26px;
      display: inline-block;
      height: $line-height;
      text-align: center;
      @include mm-icons;

      background-position: center;
      background-repeat: no-repeat;
      background-size: $icon-size $icon-size;

      &.wiki {
        background-size: $icon-size * 1.2 $icon-size;
      }
    }

    &__label {
      vertical-align: middle;
      display: inline-block;
      width: calc(100% - #{$icon-sector-width});
      font-size: 21px;
      color: #fff;

    }

    &__badge {
      vertical-align: middle;
      background-color: #004b92;
      border-radius: 50%;
      display: inline-block;
      width: 30px;
      height: 30px;
      line-height: 30px;
      font-size: 15px;
      color: #fff;
      text-align: center;

      &_new {
        background-color: $grass-green;
        font-size: 11px;
      }
    }
  }

  .mobile-nav-menu-header {
    font-size: 0;
    height: 55px;
    background-color: #0065b0;
    transition: border 0.2s ease;
    border-bottom: 1px solid #004b92;

    &__avatar {
      position: relative;
      vertical-align: top;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: 2px solid #c9c9c9;
      display: inline-block;
      margin: 2px;
      background-color: white;
      background-size: cover;
    }

    &__group-mark {
      @include mm-icons;
      width: 25px;
      height: 25px;
      bottom: -5px;
      left: -5px;
      position: absolute;
      background-color: #0065b0;
      border: solid 2px white;

      border-radius: 50%;
      background-size: 72%;
      background-repeat: no-repeat;
      background-position: center;
    }

    &__name {
      padding-left: 5px;
      overflow: hidden;
      width: calc(100% - 54px - 55px);
      display: inline-block;
      height: 100%;
      font-size: 20px;
      vertical-align: top;
      color: white;
      line-height: 55px;
    }

    &__toggle-button {
      vertical-align: top;
      float: right;
      background-color: #005ea9;
      transition: background-color 0.2s ease;
      display: inline-block;
      font-size: 35px;
      border: solid 1px #333;
      border-radius: 5px;
      padding: 5px;
      margin: 5px;
      width: 45px;
      height: 45px;
      color: white;

      i {
        vertical-align: top;
      }

      &_pushed {
        background-color: #004b92;
      }
    }
  }
</style>